import React from "react";
import { Helmet } from "react-helmet";
import { useLang } from "../../context/lang-context";
import LandingNav from "../../components/landing/LandingNav";
import LandingHero from "../../components/landing/LandingHero";
import LandingFeatures from "../../components/landing/LandingFeatures";
import LandingCustomize from "../../components/landing/LandingCustomize";
import LandingDelivery from "../../components/landing/LandingDelivery";
import LandingDownload from "../../components/landing/LandingDownload";
import LandingPartners from "../../components/landing/LandingPartners";
import LandingFooter from "../../components/landing/LandingFooter";
import "../../components/landing/landing.css";

const LandingPage: React.FC = () => {
  const { t } = useLang();

  return (
    <>
      <Helmet>
        <title>{t("Foo | Pide comida en línea", "Foo | Order food online")}</title>
        <meta name="theme-color" content="#ffbb28" />
        <meta
          name="description"
          content={t(
            "Foo App - Pide comida en línea de tus restaurantes favoritos. Descarga la app para iOS y Android.",
            "Foo App - Order food online from your favorite restaurants. Download the app for iOS and Android."
          )}
        />
        <html lang={useLang().lang} />
      </Helmet>
      <LandingNav />
      <LandingHero />
      <LandingFeatures />
      <LandingCustomize />
      <LandingDelivery />
      <LandingDownload />
      <LandingPartners />
      <LandingFooter />
    </>
  );
};

export default LandingPage;
